export default __webpack_public_path__ + "static/national-debt-relief-header-933bf9cb37c5c1007a78bb65eb372cea.png";